/** @jsx builderX.jsx */

import { builderX, Sprite, Text } from '@gongxigames/framework/core/fragments/BuilderX';

export default (
    <Sprite name='clock'>
        <Text
            position={[3628, 22]}
            style={{ fontFamily: 'PF DinDisplay Pro', fontSize: 50, fill: '#9A9A9A', align: 'center' }}
            maxWidth={260}
            name='text'
            text='01:32'
        />
    </Sprite>
);
